import { render, staticRenderFns } from "./ActivatedCardsChart.vue?vue&type=template&id=57054eb2"
import script from "./ActivatedCardsChart.vue?vue&type=script&lang=js"
export * from "./ActivatedCardsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports